import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../../api';
import '../Login/Login.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [form, setForm] = useState({ nueva_password: '', confirmar: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.nueva_password !== form.confirmar) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setLoading(true);
    try {
      const data = await authApi.resetPassword(token, form.nueva_password);
      setSuccess(data.message || 'Contraseña actualizada correctamente.');
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message || 'Token inválido o expirado.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-alert auth-alert--error">
            Token inválido. Solicita un nuevo enlace de recuperación.
          </div>
          <p className="auth-card__bottom">
            <Link to="/recuperar-password" className="auth-link">Solicitar nuevo enlace</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__logo">
          <img src={process.env.PUBLIC_URL + '/cash_logo_color-06.png'} alt="Cash Sol SAC" />
        </div>
        <h2>Nueva contraseña</h2>
        <p className="auth-card__sub">Ingresa y confirma tu nueva contraseña.</p>

        {error && <div className="auth-alert auth-alert--error">{error}</div>}
        {success && <div className="auth-alert auth-alert--success">{success}</div>}

        {!success && (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label>Nueva contraseña</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-lock"></i>
                <input type="password" name="nueva_password" value={form.nueva_password}
                  onChange={handleChange} placeholder="••••••••" required minLength={6} />
              </div>
            </div>
            <div className="auth-field">
              <label>Confirmar contraseña</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-lock"></i>
                <input type="password" name="confirmar" value={form.confirmar}
                  onChange={handleChange} placeholder="••••••••" required minLength={6} />
              </div>
            </div>

            <button type="submit" className="btn-primary auth-btn" disabled={loading}>
              {loading ? <span className="spinner-sm"></span> : (
                <><i className="fa-solid fa-key"></i> Cambiar contraseña</>
              )}
            </button>
          </form>
        )}

        <p className="auth-card__bottom">
          <Link to="/login" className="auth-link">
            <i className="fa-solid fa-arrow-left"></i> Volver al login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
